module.exports = __webpack_public_path__ + "img/9788992711005.8cb1ad38.jpg";